var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"xdvideo",staticClass:"web-video-xd",attrs:{"data-options":_vm.optionsStr}})
}
var staticRenderFns = []

export { render, staticRenderFns }